import { StoreonModule } from "storeon";
import { parseDateQueryParameter } from "../utils/date";
import { removeTrailingPeriods } from "../utils/string";
import { ModalContent } from "./enums/ModalContent";
import { IPlanInfo } from "./interfaces";

export interface IAppStore {
  appStore:IAppStoreShape;
}

export interface IAppStoreShape {
    appQueryParam: string;
    planInfo: IPlanInfo | undefined;
    modalContent: ModalContent;
}

export interface IAppEvents {
  initialState: void;
  setAppQueryParam: string;
  setPlanInfo: URLSearchParams;
  setModalContent: ModalContent;
}

const appModule: StoreonModule<IAppStore, IAppEvents> = (store) => {
  store.on("@init", initializeApp);

  store.on("setAppQueryParam", (store, event) => ({
    appStore: {
      ...store.appStore,
      appQueryParam: event,
    },
  }));

  store.on("setPlanInfo", ({ appStore }, queryParams) => ({
    appStore: {
      ...appStore,
      planInfo: {
        annualInnDeductible: queryParams.get('annual_inn_deductible'),
        annualInnOopLimits: queryParams.get('annual_inn_oop_limits'),
        annualOonDeductible: queryParams.get('annual_oon_deductible'),
        annualOonOopLimits: queryParams.get('annual_oon_oop_limits'),
        availability: queryParams.get('availability'),
        coPlan: queryParams.get('coplan'),
        dentalPlanId: queryParams.get('dental_planid'),
        enrollmentPeriodType: queryParams.get('enrollment_period_type'),
        exchange: queryParams.get('exchange'),
        metalLevel: queryParams.get('metal_level'),
        planCounty: queryParams.get('plan_county'),
        planId: queryParams.get('planid'),
        planName: queryParams.get('plan_name'),
        planState: queryParams.get('plan_state'),
        planType: queryParams.get('plan_type'),
        planZipcode: queryParams.get('plan_zipcode'),
        primaryCareVisit: queryParams.get('primary_care_visit'),
        primaryCareVisitLe: removeTrailingPeriods(queryParams.get('primary_care_visit_le') || ''),
        rateBridge: queryParams.get('ratebridge'),
        rateClasses: {
          Single: { name: 'Single', value: queryParams.get('rate_class_single'), tooltip: 'Single adult over age 19', pediatricDentalRate: null },
          Double: { name: 'Double', value: queryParams.get('rate_class_double'), tooltip: 'Married spouses/domestic partners without dependents', pediatricDentalRate: null },
          Parent: { name: 'Parent', value: queryParams.get('rate_class_parent'), tooltip: 'Single parent with dependent child/children', pediatricDentalRate: queryParams.get('pediatric_dental_parent_rate') },
          Family: { name: 'Family', value: queryParams.get('rate_class_family'), tooltip: 'Spouses/domestic partners with dependent child/children', pediatricDentalRate: queryParams.get('pediatric_dental_family_rate') },
        },
        rxCoverageGeneric: queryParams.get('rx_coverage_generic'),
        rxCoverageNonPreferred: queryParams.get('rx_coverage_nonpreferred'),
        rxCoveragePreferred: queryParams.get('rx_coverage_preferred'),
        specialistVisit: queryParams.get('specialist_visit'),
        specialistVisitLe: removeTrailingPeriods(queryParams.get('specialist_visit_le') || ''),
        currentDate: parseDateQueryParameter(queryParams.get('current_date')),
        planSlug: queryParams.get('planSlug') || '',
      },
    },
  }));

  store.on("setModalContent", ({ appStore }, event) => ({
    appStore: {
      ...appStore,
      modalContent: event,
    }
  }));
};

const initializeApp = (): IAppStore => ({
  appStore: {
    appQueryParam: "",
    planInfo: undefined,
    modalContent: ModalContent.Empty,
  },
});

export default appModule;
